<template>

    <h4>Standard lists</h4>
    <UIExampleContainer :componentId="'ListStandard'" :name="'Standard List'" :vueComponent="stdVueComponent" :vueCode="stdVueCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>

    <h5>When to use standard lists</h5>
    <p>Lists are a great way to make content easier to read, so if it can be broken down into a list it should be.</p>


    <h4>Positive and negative lists</h4>
    <UIExampleContainer :componentId="'ListPositive'" :name="'Positive List'" :vueComponent="posVueComponent" :vueCode="posVueCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>
    <UIExampleContainer :componentId="'ListNegative'" :name="'Negative List'" :vueComponent="negVueComponent" :vueCode="negVueCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>

    <h5>When to use positive and negative lists</h5>
    <p>Use the positive lists to reinforce</p>
    <UIBulletList :items="usePosList"></UIBulletList>

    <p>Use the negative lists to reinforce</p>
    <UIBulletList :items="useNegList"></UIBulletList>

    <h5>When not to use positive and negative lists</h5>
    <p>If there is only one item in the list it might be better suited to being in an alert.</p>

</template>

<script>
    import { defineComponent } from 'vue';
    import { default as UIBulletList } from '../UIBulletList.vue';
    import { default as UIExampleContainer } from '../../UIExampleContainer.vue';

    import { default as ExampleStandardComponent } from './StandardList.vue';
    import ExampleStandardCode from '!!raw-loader!./StandardList.vue';
    import { default as ExamplePositiveComponent } from './PositiveList.vue';
    import ExamplePositiveCode from '!!raw-loader!./PositiveList.vue';
    import { default as ExampleNegativeComponent } from './NegativeList.vue';
    import ExampleNegativeCode from '!!raw-loader!./NegativeList.vue';


    export default defineComponent({
        name: "Lists",
        components: {
            UIExampleContainer,
            UIBulletList
        },
        setup(_props, _context) {
            return {
                stdVueComponent: ExampleStandardComponent,
                stdVueCode: ExampleStandardCode,
                negVueComponent: ExampleNegativeComponent,
                negVueCode: ExampleNegativeCode,
                posVueComponent: ExamplePositiveComponent,
                posVueCode: ExamplePositiveCode,

                usePosList: [
                    { text: 'Things that are allowed' },
                    { text: 'Things that are required' },
                    { text: 'Things that had a positive outcome' }
                ],

                useNegList: [
                    { text: 'Things that are not allowed' },
                    { text: 'Things that are not required' },
                    { text: 'Things that had a negative outcome' }
                ]
            }
        }
    });
</script>